// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"Jx4Og30lYjtNDVKWigXA","userContainer":"QQBKpIMiSf2us0af3L08","userActions":"ZYEI4ZOk8Cuse5DO1q5E"};